import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://167.71.62.249/';
const API_URL_LAB = BASE_URL + 'lab/';
const API_URL_AUTH = BASE_URL + 'auth/';

const getAnalyses = (token) => {
  return axios.get(API_URL_LAB + 'anal-list', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getEndpoints = (token) => {
  return axios.get(API_URL_LAB + 'endpoints', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getEndpointDetail = (id, token) => {
  return axios.get(API_URL_LAB + `endpoints/${id}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getCategory = (token) => {
  return axios.get(API_URL_LAB + 'categories', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getModels = (token) => {
  return axios.get(API_URL_LAB + 'mlmodels', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getModelsArray = (token, ids = []) => {
  // Construct the query parameters for the ids
  const queryParams = ids.length ? `?${ids.map(id => `ids[]=${id}`).join('&')}` : '';

  return axios.get(`${API_URL_LAB}mlmodels-array/${queryParams}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getMLModelsByEndpoint = (endpointId, token) => {
  return axios.get(`${API_URL_LAB}mlmodels/endpoint/${endpointId}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getAnalysisDetail = (id, token) => {
  return axios.get(API_URL_LAB + `analysis/${id}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const deleteAnalysis = (id, token) => {
  return axios.delete(API_URL_LAB + `analysis/${id}/delete`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
};

const getUserInfo = (token) => {
  return axios.get(API_URL_AUTH + 'user', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const createAnalysis = (data, token) => {
  return axios.post(API_URL_LAB + "create-analysis", data, {
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  });
};

const runCalculation = (analysisId, token) => {
  return axios.post(API_URL_LAB + `run-calculation/${analysisId}`, {}, {
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  });
};

const getSelectModels = (pk, token) => {
  return axios.get(API_URL_LAB + `run-calc/${pk}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};


const getModelDetails = (pk, token) => {
  return axios.get(API_URL_LAB + `mlmodels/${pk}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const checkComputationStatus = (pk, token) => {
  return axios.get(API_URL_LAB + `computation-status/${pk}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getModelDescriptors = (token, modelIds = []) => {
  const queryParams = modelIds.length ? `?${modelIds.map(id => `model_ids[]=${id}`).join('&')}` : '';
  return axios.get(`${API_URL_LAB}model-descriptors/${queryParams}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getPredictionReport = (pk, token) => {
  return axios.get(`${API_URL_LAB}report/${pk}/`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: "blob", // important for file downloads
  });
};

const contactUs = (data, token) => {
  const config = token ? { headers: { 'Authorization': `Bearer ${token}` } } : {};
  return axios.post(API_URL_AUTH + 'contact-us/', data, config);
};

const getReadAcrossData = (predictionId, token) => {
  return axios.get(API_URL_LAB + `prediction/${predictionId}/read-across/`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getUsersList = (token) => {
  return axios.get(`${API_URL_AUTH}users-list/`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

const getUserDetailsAdmin = (userId, token) => {
  return axios.get(`${API_URL_AUTH}users-list/${userId}/`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

const toggleUserStatus = (userId, token) => {
  return axios.post(`${API_URL_AUTH}users-list/${userId}/toggle-status/`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

const adminAssignLicense = (userId, licenseType, token) => {
  return axios.post(`${API_URL_AUTH}users-list/${userId}/assign-license/`, {
    license_type: licenseType
  }, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

const getMyLicenses = (token) => {
  return axios.get(`${API_URL_AUTH}my-licenses/`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

// const purchaseLicense = (licenseType, token) => {
//   return axios.post(`${API_URL_AUTH}purchase-license/`, {
//     license_type: licenseType
//   }, {
//     headers: { Authorization: `Bearer ${token}` }
//   });
// };

const getUserLicensesAdmin = (userId, token) => {
  return axios.get(`${API_URL_AUTH}users-list/${userId}/licenses/`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

const toggleLicenseStatus = (licenseId, token) => {
  return axios.post(`${API_URL_AUTH}licenses/${licenseId}/toggle-status/`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

const deleteLicense = (licenseId, token) => {
  return axios.delete(`${API_URL_AUTH}licenses/${licenseId}/delete/`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

const getAllModelsAdmin = (token) => {
  return axios.get(`${API_URL_AUTH}admin-mlmodels/`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

const getModelDetailsAdmin = (modelId, token) => {
  return axios.get(`${API_URL_AUTH}admin-mlmodels/${modelId}/`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

const getModelVersions = (modelId, token) => {
  return axios.get(`${API_URL_AUTH}mlmodels/${modelId}/versions/`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

const deleteModelAdmin = (modelId, token) => {
  return axios.delete(`${API_URL_AUTH}admin-mlmodels/${modelId}/`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

const updateModelAdmin = (modelId, data, token) => {
  return axios.patch(`${API_URL_AUTH}admin-mlmodels/${modelId}/`, data, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

const createModelAdmin = (data, token) => {
  return axios.post(`${API_URL_AUTH}admin-mlmodels/`, data, {
    headers: { Authorization: `Bearer ${token}` }
  });
};
export default {
  createModelAdmin,
  deleteModelAdmin,
  updateModelAdmin,
  getAllModelsAdmin,
  getModelDetailsAdmin,
  getModelVersions,
  getAnalyses,
  getAnalysisDetail,
  deleteAnalysis,
  getUserInfo,
  createAnalysis,
  runCalculation,
  getSelectModels,
  getModelDetails,
  checkComputationStatus,
  getEndpoints,
  getEndpointDetail,
  getMLModelsByEndpoint,
  getModels,
  getModelsArray,
  getModelDescriptors,
  getPredictionReport,
  getCategory,
  contactUs,
  getReadAcrossData,
  getUsersList,
  getUserDetailsAdmin,
  toggleUserStatus,
  adminAssignLicense,
  getMyLicenses,
  // purchaseLicense,
  getUserLicensesAdmin,
  toggleLicenseStatus,
  deleteLicense,
};
